import React from 'react'
import { useTranslation } from 'react-i18next'
import LabelWithTooltip from '../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../../objectDetails/fields/common/PopoverContent'

export const AmenitiesLabel: React.FC<{
  tooltipContentKey?: string
}> = ({ tooltipContentKey = 'wizard.screen.otherFacilities.amenitiesPopover.content' }) => {
  const { t } = useTranslation()

  return (
    <LabelWithTooltip
      inputId='amenities'
      labelText={t('wizard.screen.otherFacilities.amenities', 'Ausstattung')}
      tooltipContent={<PopoverContent translationKey={tooltipContentKey} />}
      showMandatory={false}
      containerClassName='margin-bottom-s'
    />
  )
}
